// [CONV-EMIT-DECLS] Shared decl-walking scaffold for language emitters.
//
// The control flow "take the target-visible decls, dispatch each on d.kind to
// a per-language record/union/alias emitter, collect the lines, then join" is
// identical across brace-style converters (C#, Dart, Protobuf). Only the
// per-language emit callbacks and the file prelude differ, so those are
// parameters; the walking is centralised here so no converter re-implements it.
import { visibleDeclsForTarget, } from "../model/types.js";
const emitOne = (d, emit) => d.kind === "record" ? emit.record(d) : d.kind === "union" ? emit.union(d) : emit.alias(d);
/**
 * Walk `model`'s decls visible to `language`, emit each via `emit` (a blank
 * line separates consecutive declarations), and join into a single string.
 */
export const emitDecls = (model, language, emit, options = {}) => {
    const lines = [...(options.prelude ?? [])];
    for (const d of visibleDeclsForTarget(model.decls, language)) {
        lines.push(...emitOne(d, emit), "");
    }
    const joined = lines.join("\n");
    return options.trimTrailing === true ? joined.replace(/\n+$/, "\n") : joined;
};
//# sourceMappingURL=emit-decls.js.map